import React from "react"
import {
  Image, Stack, Text,
} from "@chakra-ui/react"
import SettingsSection from "components/settings/SettingsSection"
import Link from "components/elements/Link"
import { AndroidAppURL, iOSAppURL } from "utilities/routes"
import badgePrintingPreview from "assets/images/qr-codes-ios-app-preview.png"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { HOW_TO_SCAN_ARTICLE_LINK, MANUALLY_SEND_QR_CODES_ARTICLE_LINK } from "utilities/externalLinks"
import AppDownloadLinks from "components/AppDownloadLinks"

type Props = {
  qrCodesEnabled: boolean
}

const QRCodesLegacy = ({ qrCodesEnabled }: Props) => (
  <Stack gap={10}>
    <SettingsSection title="Distributing QR Codes">
      <Stack borderRadius="xl" bgColor="white" borderWidth={1} p={6} gap={4}>
        <Text>
          By default, the QR codes are automatically generated and sent to the
          guest when they order a ticket or confirm an RSVP, so there is no
          configuration or setup. All the QR codes are included in the emails
          with a link for the guest to print them. However, you can still
          manually generate and distribute QR codes for them.
        </Text>
        <Text>
          To learn more, see:{" "}
          <Link isExternal href={MANUALLY_SEND_QR_CODES_ARTICLE_LINK}>
            Manually Send QR Codes to Guests
          </Link>
        </Text>
      </Stack>
    </SettingsSection>
    <SettingsSection title="Scanning QR Codes">
      <Stack align="center">
        <Stack
          borderRadius="xl"
          bgColor="white"
          borderWidth={1}
          p={6}
          overflow="hidden"
          gap={8}
        >
          <Stack gap={4}>
            <Text>
              Use the built-in QR scanner in the{" "}
              <Text as="strong" fontWeight="semibold">
                Diobox iOS and Android apps
              </Text>{" "}
              to track guest check-ins. The QR scanner can perform search and
              check-in simultaneously, enabling your team to process guest
              arrivals quickly and effortlessly. The QR Scanner comes with many
              advanced features to change the scanning behavior, enforce
              check-in restrictions, manage duplicate scans, and more.
            </Text>
            <Text>
              To learn more, see:{" "}
              <Link isExternal href={HOW_TO_SCAN_ARTICLE_LINK}>
                How to Scan Guest QR Codes at Your Event
              </Link>
            </Text>
          </Stack>
          <Image
            src={badgePrintingPreview}
            display="block"
            marginLeft="auto"
            marginRight={-6}
            marginBottom={-6}
            w="75%"
          />
        </Stack>
        <AppDownloadLinks iOSAppURL={iOSAppURL} AndroidAppURL={AndroidAppURL} />
        {!qrCodesEnabled && <UpgradeAlert text="Feature requires a Professional Subscription or above." />}
      </Stack>
    </SettingsSection>
  </Stack>
)

export default QRCodesLegacy
